import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from 'merlin-library';
import { ClinicianApiEndPointConstants } from '../../utilitites/api-end-point-constants';


@Injectable({
  providedIn: 'root',
})
export class EnrollPatientTransmitterService {
  public token = localStorage.getItem('token')

  constructor(private apiService: ApiService, private http: HttpClient) { }

  
  getTransmitterData(patientId){
   return this.apiService.get(`${ClinicianApiEndPointConstants.patientListPatients}/${patientId}${ClinicianApiEndPointConstants.getTransmitterDetails}`)
  }

  updateTransmitterData(patientId,data){
    return this.apiService.put(`${ClinicianApiEndPointConstants.patientListPatients}/${patientId}${ClinicianApiEndPointConstants.getTransmitterDetails}`,data)
  }

}